import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Container,
  makeStyles,
  Typography,
} from "@material-ui/core";
import Page from "src/components/Page";
import globalActions from "src/duck/global/actions";
import { connect } from "react-redux";
import AppBar from "@material-ui/core/AppBar";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import SidesRepresentedView from "./SidesRepresentedView";
import InstitutionsView from "./InstytutionsView";
import FunctionsView from "./FunctionsView";
import WorkingGroupsView from "./WorkingGroupsView";
import { useParams } from "react-router";
import AnswerOptionView from "./AnswerOptionView";
import MessageTypeView from "./MessageTypeView";
import KmPageTitle from "src/components/layout/KmPageTitle"

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  title: {
    marginLeft: theme.spacing(3.5),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2),
    flexGrow: 1,
  },
  tabs: {
    backgroundColor: theme.palette.background.paper,
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const DictionairesView = ({ enableGlobalLoader, disableGlobalLoader }) => {
  const classes = useStyles();
  const { tabId } = useParams();
  const [value, setValue] = React.useState((parseInt(tabId))?parseInt(tabId):0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  
  return (
    <Page className={classes.root} title="Administracja - słowniki">
      <KmPageTitle>Administracja - słowniki</KmPageTitle>
      <Container maxWidth={false}>
        <Paper>
          <AppBar position="static" color="default">
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              variant="scrollable"
              scrollButtons="on"
              aria-label="scrollable auto tabs example"
            >
              <Tab label="Reprezentowane strony" {...a11yProps(0)}/>
              <Tab label="Instytucje" {...a11yProps(1)} />
              <Tab label="Funkcje" {...a11yProps(2)} />
              <Tab label="Grupy robocze" {...a11yProps(3)} />
              <Tab label="Warianty odpowiedzi" {...a11yProps(4)} />
              <Tab label="Rodzaje wiadomości" {...a11yProps(5)} />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
              <SidesRepresentedView />
          </TabPanel>
          <TabPanel value={value} index={1}>
              <InstitutionsView />
          </TabPanel>
          <TabPanel value={value} index={2}>
              <FunctionsView />
          </TabPanel>
          <TabPanel value={value} index={3}>
              <WorkingGroupsView />
          </TabPanel>
          <TabPanel value={value} index={4}>
              <AnswerOptionView />
          </TabPanel>
          <TabPanel value={value} index={5}>
              <MessageTypeView />
          </TabPanel>
        </Paper>
      </Container>
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(globalActions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(globalActions.disableGlobalLoader()),
});

export default connect(null, mapDispatchToProps)(DictionairesView);
